export default __webpack_public_path__ + "static/media/AmpinaWhite.1c0aa404.png";